import { Control, Driver, FormApi, Option, formApi, lightGreen } from '../../core';

type EmCategory = 'Options' | 'Data' | 'Risk';

export type EmCategoryList<T = any> = {
  category: EmCategory;
  list: string[];
};

export type EmCategoryForm<T = any> = {
  opt: T;
  data: T;
  risk: T;
};
type EmCategoryProps<T = any> = {
  values?: EmCategoryForm<T>;
  onCalculate?: (values: EmCategoryForm<string>) => void;
};

export type EmCategoryApi = {
  form: FormApi<EmCategoryForm>;
  set: (values: EmCategoryForm<{ label: string; value: string }>) => void;
  setDriver: (a: Driver) => void;
  clear: () => void;
};

const emptyValues = {
  opt: null,
  data: null,
  risk: null,
};

const categories: EmCategoryForm<EmCategoryList> = {
  opt: {
    category: 'Options',
    list: [],
  },
  data: {
    category: 'Data',
    list: [],
  },
  risk: {
    category: 'Risk',
    list: [],
  },
};

export function emCategoryApi({ values, onCalculate }: EmCategoryProps): EmCategoryApi {
  const toOptions = (list: string[]) => list.map((a) => ({ label: a, value: a }));
  const onChange = () => checkComplete();
  const style = { selectedColor: lightGreen };
  const form = formApi<EmCategoryForm>({
    values: { ...emptyValues, ...values },
    fields: {
      opt: {
        onChange,
        style,
        options: toOptions(categories.opt.list),
      },
      data: {
        onChange,
        style,
        options: toOptions(categories.data.list),
      },
      risk: {
        onChange,
        style,
        options: toOptions(categories.risk.list),
      },
    },
  });

  function checkComplete() {
    form.submit();

    const values = form.values.getState().value;
    const { opt, data, risk } = values;
    if (opt && data && risk) {
      calculate(values);
    }
  }
  function calculate(values: EmCategoryForm) {
    if (onCalculate) {
      onCalculate(values);
    }
  }

  function setOption(c: Control, o: Option) {
    if (o) {
      const list = c.options.getState().value;
      list.forEach((a: Option) => (a.selected = false));

      const item = list.find((a: Option) => a.value === o.value);
      if (item) {
        item.selected = true;
        c.value.setState({ value: item.value });
        c.options.setState({ value: list.slice() });
      }
    }
  }

  function set(values: EmCategoryForm) {
    const { opt, data, risk } = form.controls;
    setOption(opt, values.opt);
    setOption(data, values.data);
    setOption(risk, values.risk);
  }
  function clear() {
    set(emptyValues);
  }

  function setDriver(a: Driver) {
    if (!a?.labelsOPT) {
      return;
    }

    const { labelsOPT, labelsDATA, labelsRISK } = a;
    const { opt, data, risk } = form.controls;
    opt.options.setState({ value: toOptions(labelsOPT) });
    data.options.setState({ value: toOptions(labelsDATA) });
    risk.options.setState({ value: toOptions(labelsRISK) });

    // console.info('setDriver', opt.options.getState().value);
  }

  return {
    form,
    set,
    setDriver,
    clear,
  };
}
